import { Expose, Type } from 'class-transformer';
import { IsDate, IsEmail, IsOptional } from 'class-validator';
import { BaseDto, BaseFiltersDto } from './base.dto';
import { CardState, TagType } from '@coworkrz/cards/types';

export class CreateCardDto {
  @IsOptional()
  @IsDate()
  @Type(() => Date)
  registrationDate!: Date;

  @IsOptional()
  number: string;

  @IsOptional()
  tag: TagType;

  @IsOptional()
  isActive: boolean;
}

export class CardPreviewDto extends BaseDto {
  @Expose()
  number: string;

  @Expose()
  registrationDate: Date;

  @Expose()
  isActive: boolean;

  @Expose()
  state: CardState;

  @Expose()
  tag: string;
}

export class CardDto extends CardPreviewDto {}

export class CardsFiltersDto extends BaseFiltersDto {
  @IsOptional()
  @IsEmail()
  email?: string;
}
